import React from 'react';
import {HistoricAlertDTO, Status} from "@energy-advice/alertfan-api-client/dist/lib/generated/api";
import {DataTable} from "primereact/datatable";
import { T } from 'services/lang/LanguageService';
import {Column} from "primereact/column";
import {dateToReadableString, primereactDataTableSortDateFunction} from "utils/time-utils";
import useSafeId from 'hooks/dashboard/useDashboardComponentId';
import {Tooltip} from "react-tooltip";
import {Alert} from "@energy-advice/alertfan-api-client";
import ParametersTableBody from "./ParametersTableBody";
import {stringArrayToTags} from "../../basic/strings-array-to-tags/StringArrayToTags";
import TransposedArrayTable from "./TransposedArrayTable";

type HistoryTagsTable = {
    data: HistoricAlertDTO[]
}

const StatusIconMap: Record<Status, any> = {
    FIRING: <i data-tooltip-content={T("word.history-tags-status.firing")} style={{color: "red"}} className="pi pi-exclamation-triangle" />,
    RESOLVED: <i data-tooltip-content={T("word.history-tags-status.resolved")} style={{color: "green"}} className="pi pi-check-circle" />
}

const StatusTextMap: Record<Status, any> = {
    FIRING: T("word.history-tags-status.firing"),
    RESOLVED: T("word.history-tags-status.resolved")
}

const HistoryTagsTable = ({data}: HistoryTagsTable) => {

    const statusBody = (rowData: HistoricAlertDTO) => {
        const tooltipId = useSafeId();

        return <>
            <div id={tooltipId} className="flex align-items-center justify-content-center">
                {StatusIconMap[rowData.status]}
            </div>
            <Tooltip anchorSelect={`#${tooltipId}`} content={StatusTextMap[rowData.status]} delayShow={300}/>
        </>
    }


    if (!data) {
        return <></>
    }
    return <DataTable value={data} removableSort size="small" responsiveLayout="scroll">
        <Column header={T("word.started")}
                field="start"
                body={(e: HistoricAlertDTO) => e.start ? dateToReadableString(new Date(e.start)) : "-"}
                sortable
                sortFunction={primereactDataTableSortDateFunction}
                style={{whiteSpace: "nowrap"}}
        />
        <Column header={T("word.end")}
                field="end"
                body={(e: HistoricAlertDTO) => e.end ? dateToReadableString(new Date(e.end)) : "-"}
                sortable
                sortFunction={primereactDataTableSortDateFunction}
                style={{whiteSpace: "nowrap"}}
        />
        <Column header={T("word.status")} body={statusBody}/>
        <Column header={T("word.text")}
                field="text"
                sortable
                filter
                showFilterMatchModes={false}
                showFilterMenuOptions={false}
                filterPlaceholder={T("action.search")}
                filterField="text"
                filterMatchMode="contains"
        />
        <Column style={{width: 0}}
                body={(rowData: HistoricAlertDTO) => <TransposedArrayTable properties={rowData.timedTexts}/>}/>
        <Column header={T("word.topic-tags")}
                field="topicTags"
                body={(e: Alert) => stringArrayToTags(e.topicTags)}
                filter
                filterMatchMode="contains"
                showFilterMatchModes={false}
                showFilterMenuOptions={false}
                filterPlaceholder={T("word.tag-name")}
        />
        <Column header={T("word.item-tags")}
                field="itemTags"
                body={(e: Alert) => stringArrayToTags(e.itemTags)}
                filter
                filterMatchMode="contains"
                showFilterMatchModes={false}
                showFilterMenuOptions={false}
                filterPlaceholder={T("word.tag-name")}
        />
        <Column style={{width: 0}}
                body={(rowData: HistoricAlertDTO) => <ParametersTableBody properties={rowData.properties}/>}/>
    </DataTable>
};

export default HistoryTagsTable;